export const IMAGE_CONTAINER_CLASS_NAME = 'menu-item-image';
